import {
  SEARCH_MRD_RES,
  MRD_API_RES,
  GET_REQ_LIST,
  BACKUP_BLOB_LIST,
  GET_REQ_COUNT,
  GET_PEND_COUNT,
  VALIDATION_MRD_RES,
  RESET_STATE,
} from '../../shared/constants/ActionTypes';

const initialState = {
  searchMrdRes: [],
  MrdReqValidation: '',
  mrdApiRes: '',
  getReqList: [],
  backupBlobList:[],
  getReqCount: 0,
  getPendCount: 0,
};

const mrdUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_STATE:
      return {...initialState}; // Reset the state to the initial state
    case SEARCH_MRD_RES:
      return {
        ...state,
        searchMrdRes: action.payload,
      };
    case VALIDATION_MRD_RES:
      return {
        ...state,
        MrdReqValidation: action.payload,
      };
      case BACKUP_BLOB_LIST:
        return {
          ...state,
          backupBlobList: action.payload,
        };
    case GET_REQ_LIST:
      return {
        ...state,
        getReqList: action.payload,
      };
    case GET_REQ_COUNT:
      return {
        ...state,
        getReqCount: action.payload,
      };
    case MRD_API_RES:
      return {
        ...state,
        mrdApiRes: action.payload,
      };
    case GET_PEND_COUNT:
      return {
        ...state,
        getPendCount: action.payload,
      };
    default:
      return state;
  }
};

export default mrdUserReducer;
